import {useEffect, useState} from "react";

const useWindowWidthResize = (doOnResize=()=>null) => {

  const [returnValue, setReturnValue] = useState(doOnResize());

  useEffect(() => {

    let throttled = null;

    const handleResize = () => {
      clearTimeout(throttled)
      throttled = setTimeout(() => {
        setReturnValue(doOnResize())
      }, 100);
    }

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [doOnResize]);

  return returnValue
}

export default useWindowWidthResize;